import "scroll-watcher";
import AOS from 'aos';
import { tns } from "tiny-slider/src/tiny-slider";
import "tiny-slider/dist/tiny-slider.css";

document.addEventListener("DOMContentLoaded", function (event) {

    const watcher = new ScrollWatcher();
    let lastScroll = 0;
    watcher.on("scrolling", function(evt) {
        const direction = evt.scrollY - lastScroll;
        // console.log(evt.scrollY, direction);
            if(evt.scrollY > 100 && direction > 0) {
            document.body.classList.remove('body--showhead');
        } else {
            document.body.classList.add('body--showhead');
        }
        if(evt.scrollY > 200) {
            document.body.classList.add('body--scrolled');
        } else {
            document.body.classList.remove('body--scrolled');
        }
        lastScroll = evt.scrollY;
    });

    document.querySelector('[data-behaviour="menubutton"]').addEventListener("click", () => {
        document.body.classList.toggle('body--shownav');
    });

    // Scroll effects
    AOS.init({
        anchorPlacement: 'bottom-bottom',
        duration: 600,
        easing: 'ease-in-out'
    });

    const menuitems = document.querySelectorAll('[data-behaviour="dropdown"]');

    if(menuitems.length)
        [...menuitems].forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const otherItems = document.querySelectorAll('.header_nav--show-submenu');
                otherItems.forEach(otherItem => {
                    if(otherItem !== item.parentNode)
                        otherItem.classList.remove('header_nav--show-submenu');
                })
                item.parentNode.classList.toggle('header_nav--show-submenu');
            })
        })

    // Sliders
    var sliders = document.querySelectorAll('[data-behaviour="slider"]');

    if(sliders.length)
        [...sliders].map(slider => {
            return tns({
                container: slider,
                items: 1,
                slideBy: 'page',
                navAsThumbnails: true,
                nav: false,
                controls: true,
                controlsText: ['&lt;', '&gt;'],
                mouseDrag: true,
                // autoplay: true,
                autoplayTimeout: 5000,
                speed: 800,
                autoplayHoverPause: true,
                autoplayButtonOutput: false,
            });
        })

    // TODO
    // var MTIProjectId='203d3c1c-b441-4176-873e-1dbadf539047';
    // (function() {
    //     var mtiTracking = document.createElement('script');
    //     mtiTracking.type='text/javascript';
    //     mtiTracking.async='true';
    //     mtiTracking.src='mtiFontTrackingCode.js';
    //     (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild( mtiTracking );
    // })();
  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://matomo.atw.io/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '9']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();
});
